const initialState = {
  open: false,
  message: "",
  type: "info",
};

function appNotif(state = initialState, action) {
  switch (action.type) {
    case "SET_APPNOTIF":
      return { open: action.data.open, message: action.data.message, type: action.data.type };
    case "DISABLE_APPNOTIF":
      return { ...state, open: false };
    case "RESET_APP":
      return initialState;
    default:
      return state;
  }
}

export default appNotif;
